import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { switchMap } from "rxjs/operators";
import { GalleryGroupsSiteService } from "src/app/services/galleryGroupsSite.service";
import { GalleryImagesSiteService } from "src/app/services/galleryImagesSite.service";
import { GalleryGroupGetDetailOutputDTO } from "src/app/models/informations.models/galleryGroup.models/galleryGroupGetDetailOutputDTO.model";
import { GalleryImageGetListByGalleryGroupIdOutputDTO } from "src/app/models/informations.models/galleryImage.models/galleryImageGetListByGalleryGroupIdOutputDTO.model";
import { API_ServerAddress } from "src/app/MyAppCommonConfig";
import { SiteSEOHelperService } from "src/app/services/siteseoHelper.service";
import { DResult } from "src/app/models/common.models/dresult.model";

@Component({
  selector: "gallery",
  templateUrl: "gallery.component.html"
})
export class GalleryComponent implements OnInit {
  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          this.galleryGroupId = Number(params.get("id"));

          this.GetGalleryGroup();

          return this.GetGalleryImages();
        })
      )
      .subscribe(
        (data: DResult<GalleryImageGetListByGalleryGroupIdOutputDTO[]>) => {
          if (data.isSuccess) {
            this.galleryImages = data.result;
            this.SetDefaultPhoto();
          }
        }
      );
  }

  galleryImages: GalleryImageGetListByGalleryGroupIdOutputDTO[] = [];
  galleryGroup: GalleryGroupGetDetailOutputDTO = new GalleryGroupGetDetailOutputDTO();
  APIServerAddress: string = API_ServerAddress;
  galleryGroupId: number;
  currentSelectedImage: string = "#";
  currentSelectedImageTitle: string = "";
  currentSelectedImageDescription: string = "";

  constructor(
    private route: ActivatedRoute,
    private siteSEOHelperService: SiteSEOHelperService,
    private galleryGroupsSiteService: GalleryGroupsSiteService,
    private galleryImagesSiteService: GalleryImagesSiteService
  ) {}

  GetGalleryImages() {
    return this.galleryImagesSiteService.GetListByGalleryGroupId(
      this.galleryGroupId
    );
  }

  SetDefaultPhoto(photoId: number = 0) {
    if (this.galleryImages != null && this.galleryImages.length > 0) {
      var selectedModel = new GalleryImageGetListByGalleryGroupIdOutputDTO();
      if (photoId == 0) {
        selectedModel = this.galleryImages[0];
      } else {
        selectedModel = this.galleryImages.find(p => p.id == photoId);
      }
      this.currentSelectedImage =
        this.APIServerAddress + selectedModel.imageAddressHighQuality;
      this.currentSelectedImageTitle = selectedModel.title;
      this.currentSelectedImageDescription = selectedModel.description;
    }
  }

  GetGalleryGroup() {
    this.galleryGroupsSiteService
      .GetById(this.galleryGroupId)
      .subscribe((data: DResult<GalleryGroupGetDetailOutputDTO>) => {
        if (data.isSuccess) {
          this.galleryGroup = data.result;

          this.siteSEOHelperService.SetPageMetaData(
            this.galleryGroup.metaTitle,
            this.galleryGroup.metaDescription,
            this.galleryGroup.metaKeywords
          );
        }
      });
  }
}
